// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image and Text Block Styles */
.image-text-block {
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 40px 20px;
    background: var(--bs-body-bg-color);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
}

.image-text-block.image-left {
    flex-direction: row;
}

.image-text-block.image-right {
    flex-direction: row-reverse;
}

.image-text-content {
    flex: 1 1;
}

.image-text-content h3 {
    font-size: 1.8rem;
    margin-bottom: 15px;
    color: var(--card-title-color);
    font-weight: 600;
}

.image-text-content p {
    font-size: 1rem;
    line-height: 1.6;
    color: var(--text-color);
    margin-bottom: 0;
}

.image-text-image {
    flex: 1 1;
    max-width: 400px;
}

.image-text-image img {
    width: 100%;
    height: auto;
    border-radius: var(--border-radius);
    object-fit: cover;
}

.empty-image {
    width: 100%;
    height: 200px;
    background: var(--gray-bg-color);
    border: 2px dashed var(--border-color);
    border-radius: var(--border-radius);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--bs-gray-500);
    font-size: 14px;
}

.empty-image .mdi {
    font-size: 48px;
    margin-bottom: 10px;
}

.empty-image p {
    margin: 0;
}

/* Edit Form Styles */
.edit-form {
    display: grid;
    gap: 15px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.form-group label {
    font-weight: 600;
    color: var(--card-title-color);
    font-size: 14px;
}

.form-control {
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s ease;
    background: var(--bs-body-bg-color);
    color: var(--text-color);
}

.form-control:focus {
    outline: none;
    border-color: var(--admin-color);
    box-shadow: 0 0 0 2px rgba(0,84,96,0.25);
}

/* Responsive Design */
@media (max-width: 768px) {
    .image-text-block {
        flex-direction: column !important;
        gap: 20px;
        padding: 30px 15px;
    }
    
    .image-text-image {
        max-width: 100%;
    }
    
    .image-text-content h3 {
        font-size: 1.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/ImageAndTextBlock/ImageAndTextBlock.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,sCAAsC;IACtC,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA,sBAAsB;AACtB;IACI;QACI,iCAAiC;QACjC,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* Image and Text Block Styles */\n.image-text-block {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    padding: 40px 20px;\n    background: var(--bs-body-bg-color);\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius);\n}\n\n.image-text-block.image-left {\n    flex-direction: row;\n}\n\n.image-text-block.image-right {\n    flex-direction: row-reverse;\n}\n\n.image-text-content {\n    flex: 1;\n}\n\n.image-text-content h3 {\n    font-size: 1.8rem;\n    margin-bottom: 15px;\n    color: var(--card-title-color);\n    font-weight: 600;\n}\n\n.image-text-content p {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: var(--text-color);\n    margin-bottom: 0;\n}\n\n.image-text-image {\n    flex: 1;\n    max-width: 400px;\n}\n\n.image-text-image img {\n    width: 100%;\n    height: auto;\n    border-radius: var(--border-radius);\n    object-fit: cover;\n}\n\n.empty-image {\n    width: 100%;\n    height: 200px;\n    background: var(--gray-bg-color);\n    border: 2px dashed var(--border-color);\n    border-radius: var(--border-radius);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: var(--bs-gray-500);\n    font-size: 14px;\n}\n\n.empty-image .mdi {\n    font-size: 48px;\n    margin-bottom: 10px;\n}\n\n.empty-image p {\n    margin: 0;\n}\n\n/* Edit Form Styles */\n.edit-form {\n    display: grid;\n    gap: 15px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.form-group label {\n    font-weight: 600;\n    color: var(--card-title-color);\n    font-size: 14px;\n}\n\n.form-control {\n    padding: 8px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    font-size: 14px;\n    transition: border-color 0.2s ease;\n    background: var(--bs-body-bg-color);\n    color: var(--text-color);\n}\n\n.form-control:focus {\n    outline: none;\n    border-color: var(--admin-color);\n    box-shadow: 0 0 0 2px rgba(0,84,96,0.25);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .image-text-block {\n        flex-direction: column !important;\n        gap: 20px;\n        padding: 30px 15px;\n    }\n    \n    .image-text-image {\n        max-width: 100%;\n    }\n    \n    .image-text-content h3 {\n        font-size: 1.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
